<template>
  <div class="social">
    <div>
      <div class="item facebook">
        <svg width="10" height="19" viewBox="0 0 10 19" fill="none">
          <path
            d="M9.62343 0.00384845L7.22488 0C4.5302 0 2.78878 1.78664 2.78878 4.55194V6.6507H0.377148C0.168755 6.6507 0 6.81964 0 7.02804V10.0689C0 10.2773 0.168947 10.446 0.377148 10.446H2.78878V18.1191C2.78878 18.3275 2.95753 18.4962 3.16593 18.4962H6.31242C6.52081 18.4962 6.68957 18.3273 6.68957 18.1191V10.446H9.50932C9.71772 10.446 9.88647 10.2773 9.88647 10.0689L9.88763 7.02804C9.88763 6.92798 9.84779 6.83215 9.77718 6.76134C9.70656 6.69053 9.61034 6.6507 9.51029 6.6507H6.68957V4.87156C6.68957 4.01643 6.89334 3.58233 8.00727 3.58233L9.62304 3.58175C9.83125 3.58175 10 3.4128 10 3.2046V0.380996C10 0.172988 9.83144 0.00423329 9.62343 0.00384845Z"
            fill="white"
          />
        </svg>
        <a
          href="https://www.facebook.com/Bridgeport-United-Football-Club-661369997635018"
          target="_blank"
        ></a>
      </div>
    </div>
    <div>
      <!--<div class="item youtube">
        <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
          <path
            d="M19.6544 2.27236C19.4095 1.20872 18.5396 0.423999 17.4922 0.306941C15.0121 0.0300892 12.5019 0.0286441 10.0032 0.0300893C7.5041 0.0286441 4.99344 0.0300892 2.51334 0.306941C1.46663 0.423999 0.597265 1.20872 0.352413 2.27236C0.00392259 3.7871 0 5.44057 0 7.00011C0 8.55964 0 10.2129 0.34849 11.7274C0.592929 12.7909 1.4625 13.5756 2.50983 13.6929C4.98973 13.9699 7.50018 13.9714 9.99928 13.9699C12.4988 13.9714 15.0086 13.9699 17.4883 13.6929C18.535 13.5758 19.4052 12.7911 19.6501 11.7274C19.9988 10.2127 20 8.55944 20 7.00011C20 5.44057 20.0029 3.7871 19.6544 2.27236ZM7.41905 10.1043C7.41905 7.89198 7.41905 5.70276 7.41905 3.49022C9.53868 4.59618 11.6443 5.69471 13.7773 6.80749C11.6509 7.91035 9.54426 9.00227 7.41905 10.1043Z"
            fill="white"
          />
        </svg>
      </div>-->
    </div>
    <div>
      <div class="item instagram">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path
            d="M2.31037 0H15.6896C16.9602 0 17.9998 0.940705 17.9998 2.31018V15.6898C17.9998 17.0593 16.9602 18 15.6896 18H2.31037C1.0394 18 0 17.0593 0 15.6898V2.31018C0 0.940705 1.0394 0 2.31037 0ZM13.1122 1.99988C12.6664 1.99988 12.3022 2.36433 12.3022 2.81029V4.74992C12.3022 5.19569 12.6664 5.56033 13.1122 5.56033H15.1467C15.5924 5.56033 15.9571 5.19569 15.9571 4.74992V2.81029C15.9571 2.36433 15.5924 1.99988 15.1467 1.99988H13.1122ZM15.9656 7.61214H14.3813C14.5312 8.10153 14.6124 8.61993 14.6124 9.15626C14.6124 12.1503 12.107 14.5772 9.0171 14.5772C5.92737 14.5772 3.42239 12.1503 3.42239 9.15626C3.42239 8.61956 3.50334 8.10134 3.65341 7.61214H2.00025V15.2156C2.00025 15.6091 2.32219 15.9312 2.71585 15.9312H15.2503C15.644 15.9312 15.9659 15.6092 15.9659 15.2156V7.61214H15.9656ZM9.01691 5.45812C7.02055 5.45812 5.40194 7.02627 5.40194 8.96091C5.40194 10.8955 7.02055 12.4637 9.01691 12.4637C11.0135 12.4637 12.6322 10.8955 12.6322 8.96091C12.6322 7.02627 11.0136 5.45812 9.01691 5.45812Z"
            fill="white"
          />
        </svg>
        <a href="https://www.instagram.com/bridgeportunitedfc/" target="_blank"></a>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.social {
  position: fixed;
  top: 50vh;
  left: 0;
  transform: translate(0, -50%);
  z-index: 99;
  @media only screen and (max-width: 768px) {
    display: flex;
    top: 100%;
    left: 100%;
    transform: translate(-100%, -100%);
  }
  .item {
    width: 4.6rem;
    height: 4.3rem;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 1.3rem;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    position: relative;
    @media only screen and (max-width: 768px) {
      border-radius: none;
    }

    a {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      top: 0;
      left: 0;
    }
    svg {
      width: 95%;
      height: 95%;
    }
    @media only screen and (max-width: 768px) {
      padding: 1rem;
      svg {
        width: 75%;
        height: 75%;
      }
    }
    svg path {
      fill: #fff;
      transition: all 0.3s ease-in-out;
    }
    &.facebook {
      background-color: #4f77c0;
      &:hover {
        background: #d7e0f2;
        svg path {
          fill: #4f77c0;
        }
      }
    }
    &.youtube {
      background-color: #f14336;
      &:hover {
        background: #f7d5d7;
        svg path {
          fill: #f14336;
        }
      }
    }
    &.instagram {
      background-color: #de6262;
      &:hover {
        background: #f4dce0;
        svg path {
          fill: #de6262;
        }
      }
    }
  }
}
</style>
<script>
export default {};
</script>